import { onSnapshot, query, orderBy } from "firebase/firestore";
import { standardizeTimestamps } from "@/utils/dateUtils";
import { appointmentsCol, requestsCol, getCurrentUser } from "./utils";
import type { Appointment, AppointmentRequest } from "./types";

const isVisibleAppointment = (appointment: Appointment) =>
  appointment.excludedFromAdminMetrics !== true;

/**
 * Subscribe to real-time updates for appointments
 */
export const onAppointmentsSnapshot = (
  callback: (items: Appointment[]) => void
): (() => void) => {
  const user = getCurrentUser();
  if (!user) {
   
    return () => {}; // Return empty unsubscribe function
  }

  const q = query(appointmentsCol(user.uid), orderBy("datetime", "desc"));

  return onSnapshot(
    q,
    (snapshot) => {
      const items = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...standardizeTimestamps(doc.data()),
      })) as Appointment[];

      callback(items.filter(isVisibleAppointment));
    },
    (error) => {
      console.error("Error in appointments snapshot:", error);
      // Optionally call callback with empty array on error
      callback([]);
    }
  );
};

/**
 * Subscribe to real-time updates for appointment requests
 */
export const onRequestsSnapshot = (
  callback: (items: AppointmentRequest[]) => void
): (() => void) => {
  const user = getCurrentUser();
  if (!user) {
   
    return () => {}; // Return empty unsubscribe function
  }

  const q = query(requestsCol(user.uid), orderBy("createdAt", "desc"));

  return onSnapshot(
    q,
    (snapshot) => {
      const items = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...standardizeTimestamps(doc.data()),
      })) as AppointmentRequest[];

      callback(items);
    },
    (error) => {
      console.error("Error in requests snapshot:", error);
      // Optionally call callback with empty array on error
      callback([]);
    }
  );
};
